import React, { Component } from 'react';
import Modal from 'react-modal';
import { CanDrop } from 'utils/permissions';

class DropColumnButton extends Component {
  state = {
    isOpen: false,
  };

  handleOnPress = e => {
    e.preventDefault();
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  action = () => {
    this.props.dropFirstColumn();
    this.closeModal();
  };

  render() {
    if (!CanDrop(this.props.user)) {
      return null;
    }

    return (
      <div style={styles.container}>
        <button
          className="button"
          style={styles.button}
          onClick={this.handleOnPress}
        >
          Drop Column
        </button>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.isOpen}
          shouldCloseOnOverlayClick
          onRequestClose={this.closeModal}
          style={styles.modal}
        >
          <div>
            <div style={{ paddingBottom: 15, textAlign: 'center' }}>
              <p>
                Are you sure you want to remove the first column on this board?
              </p>
              <p>This cannot be undone.</p>
            </div>

            <div style={styles.buttonContainer}>
              <button
                className="button"
                style={styles.actionButton}
                onClick={this.action}
              >
                Drop First Column
              </button>
              <button
                className="button"
                style={styles.cancelButton}
                onClick={this.closeModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const styles = {
  container: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
  },
  buttonContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    padding: '0.6rem 0.8rem',
    minWidth: '10rem',
  },
  actionButton: {
    minWidth: '10rem',
    fontSize: '3rem',
    padding: '0.6rem 0.8rem',
  },
  cancelButton: {
    minWidth: '10rem',
    fontSize: '3rem',
    backgroundColor: 'red',
    padding: '0.6rem 0.8rem',
  },
  modal: {
    overlay: {
      zIndex: 15,
      background: 'rgba(0,0,0,.33)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      position: 'unset',
      minWidth: '20%',
      padding: 32,
      fontSize: '3rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
};

export default DropColumnButton;



// WEBPACK FOOTER //
// ./src/components/DropColumnButton/DropColumnButton.js